import { Pipe, PipeTransform } from '@angular/core';

import { ReportCommissionPaid } from '../models';

@Pipe({
    name: 'filterReportCommissionPaid',
    standalone: false
})
export class FilterReportCommissionPaidPipe implements PipeTransform {
	transform(commissions: ReportCommissionPaid[], onlyNegativeAmounts: boolean): ReportCommissionPaid[] {
		return commissions ? commissions.filter(c => (!onlyNegativeAmounts || c.amount < 0) && c.addDate) : commissions;
	}
}
